// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.System__aligned-left-d37e3e {
  justify-self: flex-start;
  margin: 0;
}

.System__text-d93f72 {
  display: inline-block;
  border-radius: 100px;
  background: var(--average-background);
  padding: 4px 8px;
  color: var(--text-on-background);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/System/System.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,oBAAA;EACA,qCAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;EACA,8CAAA;EACA,kBAAA;AACF","sourcesContent":[".aligned-left {\n  justify-self: flex-start;\n  margin: 0;\n}\n\n.text {\n  display: inline-block;\n  border-radius: 100px;\n  background: var(--average-background);\n  padding: 4px 8px;\n  color: var(--text-on-background);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aligned-left": `System__aligned-left-d37e3e`,
	"alignedLeft": `System__aligned-left-d37e3e`,
	"text": `System__text-d93f72`
};
module.exports = ___CSS_LOADER_EXPORT___;
